<template>
  <div id="app" :class="themeClass">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'
import '@/css/theme.scss'

export default {
  name: "App",
  computed: {
    themeClass () {
      const designType = this.$store.getters.domainConfig?.designType || 1;
      return designType === 2 ? 'theme-orange' : '';
    }
  },
  created () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    const deviceType = this.detectDeviceType();
    this.$store.commit('setDeviceType', deviceType);

    // 同步 hostInject 配置
    if (this.$store.getters.domainConfig?.hostInject) {
      this.$store.commit('setHostInject', this.$store.getters.domainConfig.hostInject);
    }
  },
  async mounted () {
    await this.fetchCategory();
  },
  methods: {
    fetchCategory () {
      this.$global.server.postAPI({
        method: 'get',
        params: {
          pageSize: '50',
          pageNum: '1',
        },
        url: '/name/categories',
      })
        .then(response => {
          if (response && response.data) {
            // 将接口返回存储到vuex
            this.$store.commit('setGender', response.data.gender);
            this.$store.commit('setStyle', response.data.style);
            this.$store.commit('setMeaning', response.data.meaning);
            console.log('页面选项获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取页面选项失败:', error);
        });
    },
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 增加触摸设备检测作为辅助判断
          const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (hasTouch && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    },

  }
};
</script>
